import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { createWidget } from '@typeform/embed';
import { TypeformService } from '../../service/typeform.service';

@Component({
  selector: 'app-typeform',
  imports: [],
  templateUrl: './typeform.component.html',
  styleUrl: './typeform.component.scss',
})
export class TypeformComponent implements AfterViewInit, OnDestroy {
  @Input() typeformId!: string;
  @Input() _editable!: string;

  @Input() _uid!: string;
  @Input() component!: string;

  @ViewChild('typeformContainer', { static: false })
  typeformContainer!: ElementRef;

  private typeformWidget: any;
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private typeformService: TypeformService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngAfterViewInit(): void {
    if (this.isBrowser && this.typeformId && this.typeformContainer) {
      const actualFormId = this.typeformId;

      this.typeformWidget = createWidget(actualFormId, {
        container: this.typeformContainer.nativeElement,
        onSubmit: async ({ responseId }: any) => {
          console.log('Form submitted!');
          console.log('Response ID:', responseId);

          try {
            await this.typeformService.handleFormSubmission(
              actualFormId,
              responseId
            );
            console.log(
              'Form data successfully processed and sent to analytics'
            );
          } catch (error) {
            console.error('Error processing form submission:', error);
          }
        },
        onHeightChanged: ({ height }: any) => {
          this.typeformContainer.nativeElement.style.height = `${height}px`;
          console.log('Typeform height changed to:', height);
        },
      });
    }
  }

  ngOnDestroy(): void {
    if (this.isBrowser && this.typeformWidget) {
      this.typeformWidget.unmount();
    }
  }
}
